import { call, put, takeLatest } from "redux-saga/effects";
import {
  editPaperCurriculumStart,
  editPaperCurriculumSuccess,
  editPaperCurriculumFailure,
  editPaperStart,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import {
  httpCreatePaperCurriculum,
  httpPaperCurriculumDelete,
} from "../../../services/paper";

export function* handleEditCurriculum({ payload }) {
  const { data, callback } = payload;
  let curriculumFile = data?.curriculumUrl;
  if (data?.prevCurriculumUrl) {
    yield call(httpPaperCurriculumDelete, data.prevCurriculumUrl);
  }
  const response = yield call(httpCreatePaperCurriculum, curriculumFile);
  const { success, raw, message } = response;

  if (success) {
    yield put(editPaperCurriculumSuccess());
    let modData = { ...data, curriculumUrl: raw?.id };
    const { prevCurriculumUrl, ...finalPayload } = modData;
    yield put(editPaperStart({ data: finalPayload, callback }));
  } else {
    yield put(editPaperCurriculumFailure());
    networkErrorHandler(response.statusCode, message || raw);
  }
}

export default function* onEditPaperCurriculum() {
  yield takeLatest(editPaperCurriculumStart.type, handleEditCurriculum);
}
